import classnames from 'classnames'
import { Spinner } from '../Spinner/Spinner'

type TableLoadingOverlayProps = {
    show: boolean
    title?: string
    coverContainer?: boolean
}

export const TableLoadingOverlay: React.FC<TableLoadingOverlayProps> = (
    props
) => {
    const { show, title, coverContainer } = props
    const className = classnames(
        coverContainer
            ? 'absolute inset-0 z-[3500] backdrop-blur-[10px] transition-all -mt-6'
            : 'absolute -inset-4 z-20 backdrop-blur-[10px] transition-all',
        {
            'opacity-0 pointer-events-none': !show,
        }
    )

    return (
        <div className={className} data-testid="table-report-loader">
            <div className="absolute inset-0 flex items-center justify-center bg-white/10">
                <div className="space-y-2">
                    <div className="flex justify-center text-azure">
                        <Spinner size={40} width={6} />
                    </div>
                    {title && (
                        <div dangerouslySetInnerHTML={{ __html: title }} />
                    )}
                </div>
            </div>
        </div>
    )
}
